/**
 * Client-side recent takes shelf (suite/binder gens).
 * Mirrored conceptually under ./data/takes.
 */

export type TakeItem = {
  id: string;
  /** data:audio/... or blob URL or remote URL */
  src: string;
  text: string;
  backend: string;
  createdAt: number;
  format?: string;
  refName?: string;
  durationSec?: number;
};

const KEY = "voiceforge.takes.v1";
const MAX = 40;

export function loadTakes(): TakeItem[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw) as TakeItem[];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function pushTake(item: Omit<TakeItem, "id" | "createdAt">): TakeItem {
  const full: TakeItem = {
    ...item,
    id: `take_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    createdAt: Date.now(),
  };
  const next = [full, ...loadTakes()].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // drop oldest data URLs if storage full
    const slim = next.map((t, i) =>
      i > 10 && t.src.startsWith("data:") ? { ...t, src: "" } : t,
    );
    try {
      localStorage.setItem(KEY, JSON.stringify(slim.filter((t) => t.src)));
    } catch {
      /* ignore */
    }
  }
  return full;
}

export function clearTakes(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
